import { render, staticRenderFns } from "./tech-empowerment.vue?vue&type=template&id=519aff7b&scoped=true"
import script from "./tech-empowerment.vue?vue&type=script&lang=js"
export * from "./tech-empowerment.vue?vue&type=script&lang=js"
import style0 from "./tech-empowerment.vue?vue&type=style&index=0&id=519aff7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519aff7b",
  null
  
)

export default component.exports